import { useTranslation } from 'react-i18next';

import { useGermanStatusBoard } from 'features/Croptimizer/screen/1Board/components/BoardSteps/components/1Status/German/hooks/useGermanStatusBoard';
import { useCropBoard } from 'features/Croptimizer/screen/1Board/components/BoardSteps/components/3Crop/hooks/useCropBoard';

import Select from '../../../../components/Select';

type CropTypeFieldProps = {
  isGerman?: boolean;
  defaultCropIndex?: number;
  titleHidden?: boolean;
};

const CropTypeField = ({ isGerman = false, titleHidden = false, defaultCropIndex = 0 }: CropTypeFieldProps) => {
  const { t } = useTranslation();

  const {
    cropSelect,
    handleCropChange,
    cropType,
  } = isGerman
    ? useGermanStatusBoard()
    : useCropBoard({ defaultCropIndex });

  return (
    <Select
      options={cropSelect}
      onChange={handleCropChange}
      title={titleHidden ? '' : t('cropType')}
      placeholder={t('selectValue')}
      isBlueBg
      value={
        cropType?.length > 0
          ? [
            {
              value: cropType,
              label: cropType,
            },
          ]
          : []
      }
    />
  );
};

export default CropTypeField;
